import React from "react"

export default class AbstractCanvas extends React.PureComponent {
  constructor(props) {
    super(props)
    this.canvas = React.createRef()
  }

  getCanvasContext = (width, height) => {
    // Will be greater than 1 (often, but not always, 2) on HighDPI screens.
    const pixelRatio = window.devicePixelRatio || 1

    const canvas = this.canvas.current
    if (!canvas) {
      return
    }

    canvas.width = width * pixelRatio
    canvas.height = height * pixelRatio // Clears the canvas...

    const g = canvas.getContext("2d")
    g.scale(pixelRatio, pixelRatio)

    return g
  }

  // Draw gridlines
  gridlineLayer(g, x, y, height, width) {
    g.save()
    g.strokeStyle = "#CDCDCD"
    g.beginPath()
    x.ticks().forEach((time, i) => {
      g.moveTo(x(time), 0)
      g.lineTo(x(time), height)
    })

    y.ticks().forEach((value, i) => {
      g.moveTo(0, y(value))
      g.lineTo(width, y(value))
    })

    //Make sure we have a gridline across the top of the plot
    g.moveTo(0, 0)
    g.lineTo(width, 0)

    //Make sure we have a gridline across the left edge of the plot
    g.moveTo(0, 0)
    g.lineTo(0, height)

    //Make sure we have a gridline across the right edge of the plot
    g.moveTo(width, 0)
    g.lineTo(width, height)

    g.stroke()
    g.restore()
  }

  // Draw a filled rectangle on the canvas
  filledRectangleLayer(g, x, width, height, color = "green", opacity = 0.5, showBorder = false) {
    g.save()
    g.beginPath()
    g.rect(x, 0, width, height)
    if (showBorder) {
      g.setLineDash([4, 4])
      g.stroke()
    }
    g.fillStyle = color
    g.globalAlpha = opacity
    g.fill()
    g.globalAlpha = 1.0
    g.restore()
  }
}
